var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteUserIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-trash-1523236",
    transform: "translate(-165.192 -67.203)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10087",
    "data-name": "Caminho 10087",
    d: "M173.215,67.2a2.9,2.9,0,0,0-1.864.664,5.115,5.115,0,0,1-1.25.875.512.512,0,0,0-.318.461h-4.591v1h16v-1H176.6a.512.512,0,0,0-.318-.461,5.157,5.157,0,0,1-1.265-.875,2.817,2.817,0,0,0-1.8-.664Zm-6.568,3.5V83.961a1.956,1.956,0,0,0,2.189,2.242h8.727a1.954,1.954,0,0,0,2.174-2.242V70.7Zm2.667,3.25h.97v9h-.97Zm3.394,0h.97v9h-.97Zm3.394,0h.97v9h-.97Z",
    fill: "#9d9d9d"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteUserIcon);
export default __webpack_public_path__ + "static/media/delete_user_icon.b6e65e1e2184a0aef3d5fa6b6965ed96.svg";
export { ForwardRef as ReactComponent };